<template>
    <div class="local-forum">
        <newsTitle :data="newsData"></newsTitle>
        <newsTitle :data="newsDataimg"></newsTitle>
        <div class="local-forum-swiper">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item><img src="../../assets/img/index/banner1.png" alt=""></van-swipe-item>
                <van-swipe-item><img src="../../assets/img/index/banner1.png" alt=""></van-swipe-item>
                <van-swipe-item><img src="../../assets/img/index/banner1.png" alt=""></van-swipe-item>
                <van-swipe-item><img src="../../assets/img/index/banner1.png" alt=""></van-swipe-item>
              </van-swipe>
        </div>
        <newsTitle :data="newsData"></newsTitle>
        <newsTitle :data="newsDataimg"></newsTitle>
        <router-link :to="{path:'/pushAtrends'}"><img class="pushTrends" src="../../assets/img/icon/close.png" alt=""></router-link>
    </div>
</template>
<script>
    import newsTitle from '../../components/newsTitle.vue'
    export default {
        data(){
            return {
                newsData:{
                    title:"我市广大党员干部群众认真学习、热议省委书记王国生在安调研讲话精神",
                    author:"飞翔的鸟",
                    time:"2019-12-10 8:45:12",
                    commentNum:"2",
                    viewtNum:"3"
                },
                newsDataimg:{
                    title:"我市广大党员干部群众认真学习、热议省委书记王国生在安调研讲话精神11",
                    author:"飞翔的鸟",
                    time:"2019-12-10 8:45:12",
                    commentNum:"2",
                    imgList:[
                        {
                            imgSrc:"../assets/img/logo.png"
                        },
                        {
                            imgSrc:"../assets/img/logo.png"
                        },
                    ],
                    viewtNum:"3"
                }
            }
        },
        components:{newsTitle}
    }
</script>
<style scoped>
    .local-forum{
        background-color: #F5F5F5;
    }
    .local-forum-swiper{
        width: 686px;
        margin: 14px auto 30px;
        border-radius:10px;
        overflow: hidden;
    }
    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 306px;
        text-align: center;
        background-color: #39a9ed;
    }
    .pushTrends{
        position: fixed;
        width: 104px;
        height: 104px;
        right: 27px;
        bottom: 60px;
    }
</style>